export const enum AppMutationNames {
  updateUserId = 'APP_UPDATE_USER_ID',
  updateUserLastName = 'APP_UPDATE_USER_LAST_NAME',
  updateUserFirstName = 'APP_UPDATE_USER_FIRST_NAME',
  updateUserRoles = 'APP_UPDATE_USER_ROLES',
}

export const enum AppActionNames {}

export const enum AppGetterNames {
  userFullName = 'APP_USER_FULL_NAME',
  isAdminUser = 'APP_IS_ADMIN_USER',
  isRocheConsultant = 'APP_IS_ROCHE_CONSULTANT',
  isCareTeamUser = 'APP_IS_CARE_TEAM_USER',
  isExecUser = 'APP_IS_EXEC_USER',
  isNursingHomeUser = 'APP_IS_NURSING_HOME_USER',
}
